import "core-js/modules/es.array.push.js";
import axios from "axios";
import Cookie from "js-cookie";
import router from "../router/index";
import * as pathConfig from "./config";
import { Loading, Message } from "element-ui";
import qs from "qs";
axios.defaults.timeout = 50000; // 请求
// loading 计数
let requestCount = 0;
let loading;
let timer;
function showLoading() {
  if (requestCount === 0) {
    loading = Loading.service({
      spinner: "el-icon-loading",
      //loading样式类名
      background: "rgba(0,0,0,0)",
      text: "正在加载数据..."
    });
  }
  requestCount++;
}
function tryHideLoading() {
  requestCount--;
  if (requestCount === 0) {
    loading.close();
    clearTimeout(timer);
  }
}

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (config.url == "/p/file/uploadImFile" || config.url == "/p/prodPurchaseOrder/upload") {
    config.headers["Content-Type"] = "multipart/form-data;";
  } else if (config.url == "/p/user/recentBrowse") {
    config.headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
  } else {
    config.headers["Content-Type"] = "application/json; charset=utf-8";
  }
  var token = localStorage.accessToken;
  if (token && (config.url.indexOf("/p/") === 0 || config.url == "/user/registerOrBindUser" || config.url == "/search/page" || config.url == "/prod/enterpriseProdList" || config.url == "/shop/getAgentShops" || config.url == '/prod/prodQuantity' || config.url == "/prod/prodInfo" || config.url == '/shop/getTradeShops' || config.url == '/shop/getOrderContractShops' || config.url == '/complaint/save' || config.url == '/search/prod/page' || config.url == '/sms/sendUpdatePwdCode')) {
    config.headers["Authorization"] = token;
    // 携带B端标识(需要可在登录成功时就存储，类同token写法)
    config.headers["loginType"] = 1;
  }
  if (config.url.indexOf("/p/user/conversations") === 0 || config.url == "/p/user/recentBrowse") {
    config.url = pathConfig.imPath + config.url;
  } else {
    config.url = pathConfig.path + config.url;
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  const code = parseInt(response.status);
  if (code == 400) {
    // Message.warning(response.data);
    Message.error(response.data);
  } else if (code == 500) {
    Message.error("服务器出了点小差~");
  } else if (code == 401) {
    // 未登录
    // Message.error("您还没有登录哦~");
    localStorage.accessToken = "";
    // router.replace('/login')
  } else if (code == 204) {
    Message.error("活动已结束！");
    router.push({
      path: "/index"
    });
    return;
  }
  return response;
}, function (error) {
  // console.log(error, 'err')
  let code = parseInt(error.response.status);
  if (code == 400) {
    Message.warning(error.response.data);
  } else if (code == 500) {
    Message.error("服务器出了点小差~");
  } else if (code == 401) {
    // 未登录
    // Message.error("您还没有登录哦~")
    localStorage.accessToken = "";
    // router.replace('/login')
  } else if (code == 204) {
    Message.error("活动已结束！");
    router.push({
      path: "/index"
    });
    return;
  }
  return Promise.reject(error);
});
function get(url, params, showLoad = true) {
  if (showLoad) {
    showLoading();
  }
  return new Promise((resolve, reject) => {
    axios.get(`${url}`, {
      params: params
    }).then(res => {
      if (showLoad) {
        tryHideLoading();
      }
      let code = res.status;
      if (code == 200) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      if (showLoad) {
        tryHideLoading();
      }
      reject(err);
    });
  });
}
function post(url, params, data, showLoad = true) {
  if (showLoad) {
    showLoading();
  }
  return new Promise((resolve, reject) => {
    axios
    //  qs.stringify({ a: ['b', 'c'] }, { arrayFormat: 'indices' })  =>   'a[0]=b&a[1]=c'
    // .post(`${url}`, qs.stringify(params, { arrayFormat: "indices" }))
    // .post(`${url}`, params) 
    ({
      url: `${url}`,
      method: 'post',
      data: data,
      // body参数
      params: params // query参数
    }).then(res => {
      if (showLoad) {
        tryHideLoading();
      }
      let code = res.status;
      if (code == 200) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      if (showLoad) {
        tryHideLoading();
      }
      reject(err);
    });
  });
}
function postFile(url, params) {
  return new Promise(resolve => {
    axios.post(url, params).then(res => {
      resolve(res);
    }).catch(err => {
      resolve(err);
    });
  });
}
function deletee(url, params, data, showLoad = true) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {
      params: params,
      data: data // body参数
    }).then(res => {
      if (showLoad) {
        tryHideLoading();
      }
      let code = res.status;
      if (code == 200) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      if (showLoad) {
        tryHideLoading();
      }
      reject(err);
    });
  });
}
function put(url, params, data, showLoad = true) {
  if (showLoad) {
    showLoading();
  }
  return new Promise((resolve, reject) => {
    axios({
      url: `${url}`,
      method: 'put',
      data: data,
      // body参数
      params: params // query参数
    })
    // .put(`${url}`, {
    //   params: params,
    // })
    .then(res => {
      if (showLoad) {
        tryHideLoading();
      }
      let code = res.status;
      if (code == 200) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      if (showLoad) {
        tryHideLoading();
      }
      reject(err);
    });
  });
}
export { get, post, postFile, deletee, put };